import { render, staticRenderFns } from "./PointItem.vue?vue&type=template&id=737d3016&scoped=true&"
import script from "./PointItem.vue?vue&type=script&lang=js&"
export * from "./PointItem.vue?vue&type=script&lang=js&"
import style0 from "./PointItem.vue?vue&type=style&index=0&id=737d3016&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d3016",
  null
  
)

export default component.exports